import resolved from './tokens/tokens.resolved.json';

/**
 * 디자인 토큰의 공개 API.
 * `tokens/` 아래는 생성물이다(`npm run tokens:build`). 직접 고치지 않는다.
 *
 * - 클래스로 표현할 수 있으면 Tailwind 유틸리티를 쓴다(`bg-bg-primary`, `typo-body`).
 * - 클래스로 표현할 수 없는 곳(인라인 style · canvas · 차트)만 `tokenVar` / `resolvedTokens`.
 */
export type {
  ColorToken,
  DimensionToken,
  FontFamilyToken,
  FontWeightToken,
  NumberToken,
  ShadowToken,
  TokenPath,
  TypographyToken,
} from './tokens/tokens';
export { tokenVar } from './tokens/tokens';

/** 별칭을 푼 원래 값(기본 모드). 테스트 · 차트 · 디자인 확인 페이지가 읽는다 */
export const resolvedTokens: Readonly<Record<string, unknown>> = resolved.default;

export const tokenSourceHash: string = resolved.sourceHash;
